import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";
import axiosInstance from "../../../utils/axiosInstance";

const BillPrintView = () => {
  const { orderId } = useParams();
  const [order, setOrder] = useState(null);

  useEffect(() => {
    const fetchBill = async () => {
      const res = await axiosInstance.get(
        `${import.meta.env.VITE_API_BASE_URL}/api/orders/${orderId}`
      );

      setOrder(res.data.order);   // 👈 IMPORTANT — your JSON has { order: {...} }
    };

    fetchBill();
  }, [orderId]);

  if (!order) return <p>Loading…</p>;

  const patient = order.patient;
  const tests =
    order.orderMembers?.[0]?.orderMemberPackages || [];

  return (
    <div className="p-6 w-[900px] mx-auto">

      {/* HEADER */}
      <h1 className="text-center font-bold text-lg">
        NAVAMI DIAGNOSTICS
      </h1>

      <p className="text-center text-xs">
        #2914, Rajiv Nagar 3rd Stage, Mysuru – 570015<br />
        Mob: 9108322333 / 0821-2332699
      </p>

      <h2 className="text-center mt-2 underline font-semibold">
        CASH BILL
      </h2>

      {/* PATIENT + BILL INFO */}
      <div className="grid grid-cols-2 mt-4 text-xs gap-4">
        <div>
          <p><b>NAME :</b> {patient?.fullName}</p>
          <p><b>AGE/SEX :</b> {patient?.age || "-"} / {patient?.gender || "-"}</p>
          <p><b>CONTACT # :</b> {patient?.contactNo}</p>
          <p><b>REFERRED BY :</b> -</p>
        </div>

        <div>
          <p><b>ORDER # :</b> {order.orderNumber}</p>
          <p><b>BILLED TIME :</b> {new Date(order.createdAt).toLocaleString()}</p>
          <p><b>PAYMENT STATUS :</b> {order.paymentStatus?.toUpperCase()}</p>
        </div>
      </div>

      {/* TABLE */}
      <table className="w-full mt-4 border text-xs">
        <thead>
          <tr className="border">
            <th className="border p-1">Sl No</th>
            <th className="border p-1 text-left">Bill Item</th>
            <th className="border p-1">Quantity</th>
            <th className="border p-1">Amount (Rs.)</th>
          </tr>
        </thead>

        <tbody>
          {tests.map((pkg, i) => (
            <tr key={pkg.id}>
              <td className="border p-1 text-center">{i + 1}</td>
              <td className="border p-1">{pkg.test?.name}</td>
              <td className="border p-1 text-center">1</td>
              <td className="border p-1 text-right">{pkg.test?.offerPrice}</td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* TOTALS */}
      <div className="text-right mt-3 text-xs">
        <p><b>SUB TOTAL:</b> {order.totalAmount}</p>
        <p><b>TOTAL DISCOUNT:</b> {order.discount}</p>
        <p><b>TOTAL:</b> {order.finalAmount}</p>
      </div>

      {/* FOOTER */}
      <p className="mt-4 text-xs font-semibold">
        Net Received Rs. {order.finalAmount}
      </p>

      <ul className="mt-4 text-xs">
        <li>• Scan data stored for up to 1 month.</li>
        <li>• Copy of bill required for reports/films.</li>
        <li>• Contact: +91 9108322333</li>
      </ul>

      <div className="text-right mt-10 text-xs">Signature</div>

      <button
        onClick={() => window.print()}
        className="mt-6 border px-3 py-1 text-xs"
      >
        Print
      </button>
    </div>
  );
};

export default BillPrintView;
